import '../shared/sv-hover-intent';

import * as Localizer from 'Localizer';
import * as THD from 'hfs.global.namespace';
import * as bodyScrollLock from 'body-scroll-lock';
import * as localizationDrawer from 'localization-drawer';

import $ from 'jquery';
import { tooltip as ToolTip } from 'plugin.tooltip';
import headerStorefinderCore from 'header.storefinder.core';
import utils from '../shared/utils';
import * as Mustache from 'mustache';

const storeFinder = {};
const privateMethods = {};
let storeFinderTooltip;
const privateData = {};
let drawerElement = document.querySelector('#myStore-overlay');
const { delegateListeners, addListenersToAll, setInnerHtml } = utils;
privateData.templates = {};
privateData.templates.notInRange = '' +
'<div class="grid">' +
'<div class="col__12-12">' +
' looks like this store isn\'t near your delivery area. Need to ' +
'<a href="{{storeFinderHref}}" class="list__link softlink_updatestore" rel="hfLocModal">update your store</a>?' +
'</div>' +
'</div>' +
'';

/**
 * * Attach tooltip to mystore element on the page.
 */
privateMethods.attachTooltipToMyStore = function _attachTooltipToMyStore() {
  // do a manual control over opening/closing
  storeFinderTooltip = new ToolTip(document.getElementById('myStore'), {
    type: 'click',
    noPad: true,
    onCreate: (tooltipContentElement) => {
      tooltipContentElement.innerHTML = '<div class="MyStore__preloaderSpinner">&nbsp;</div>';
    },
    onOpen: headerStorefinderCore.openStorefinderInTooltip
  })
};

privateMethods.createMask = function _createMask() {
  let mask = document.getElementById('localization-mask');
  if (!mask) {
    mask = document.createElement('div');
    mask.classList.add('localization__mask--fixed');
    mask.id = 'localization-mask';
    mask.addEventListener('click', privateMethods.closeDrawer);
    document.body.appendChild(mask);
  }
};

privateMethods.updateStoreTitle = function _updateStoreTitle(storeTitleEvent) {
  setInnerHtml('#myStore .MyStore__label', storeTitleEvent?.detail?.html)
};

privateMethods.isScrolledToTop = function _isScrolledToTop() {
  return !(window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
  );
}

/**
 * * Close simple menu (created from hamburger)
 */
privateMethods.launchDrawer = function _launchDrawer() {
  document.dispatchEvent(new CustomEvent('showSimpleFlyout', {detail:{open:false}}))
  privateData.isDrawerOpen = true;

  /**
   * * IF sticky header is present AND page is NOT scrolled to top,
   * * AKA, message bar is scrolled out of view
   * * THEN remove localization offset
   * * IF NOT sticky header, no action required
   */

  const stickyHeader = document.getElementsByClassName('Header3-sticky-desktop');
  if (stickyHeader.length > 0) {
    if (!privateMethods.isScrolledToTop()) {
      document.querySelector('.localization').style.marginTop = 0;
    }
  }
  const homeDecorFurnitureSubnav = document.getElementsByClassName('homeDecorFurnitureSubnav');
  if (homeDecorFurnitureSubnav.length > 0) {
    document.querySelector('.localization').style.marginTop = 0;
  }

  privateMethods.createMask();
  bodyScrollLock.disableBodyScroll(privateData.drawerElement);
  const localizationInstance = new localizationDrawer.default({
    channel: 'desktop',
    hostName: THD_GLOBAL.nonSecureHostName,
    selectedStoreId: privateData.myStore.storeId
  })
  localizationInstance.createDrawer();
  new SV.HoverIntent(document.querySelectorAll('.ShoppingLinks__item'), {
    onEnter: () => {
      document.dispatchEvent(new CustomEvent('closeDrawer', { detail : { open: false } }));
    },
    onExit: () => {}
  });
};

privateMethods.closeDrawer = function _closeDrawer() {
  const mask = document.getElementById('localization-mask');
  const drawerContent = document.getElementById('myStore-overlayWrapper');
  const drawer = document.getElementById('myStore-overlay');
  if (mask && drawerContent && drawer && privateData.isDrawerOpen) {
    privateData.isDrawerOpen = false;
    document.body.removeChild(mask);
    drawerContent.innerHTML = '';
    drawer.classList.add('u--hide');
    bodyScrollLock.enableBodyScroll(privateData.drawerElement);
  }
};

privateMethods.toggleDrawer = function _toggleDrawer(event) {
  event.preventDefault();
  if (privateData.isDrawerOpen) {
    privateMethods.closeDrawer();
  } else {
    privateMethods.launchDrawer();
  }
};

storeFinder.openStoreDropdownInTooltip = function _openStoreDropdownInTooltip(tooltip, complete) {
  const myStoreDropdown = document.getElementById('myStore_Softlink_wrapper');
  myStoreDropdown?.classList.remove('u--hide');
  tooltip?.appendChild(myStoreDropdown);
  complete();
};

storeFinder.softLink = function _softLink() {
  var currentStoreHTML = Mustache.render(privateData.templates.notInRange, privateData);
  utils.setInnerHtml('#myStore_Softlink_wrapper', currentStoreHTML);

  let softlinkInfoTooltip = new ToolTip(document.getElementById('myStore_softlink'), {
    type: 'click',
    noPad: true,
    content: ' ',
    closeOnClick: true,
    onOpen: storeFinder.openStoreDropdownInTooltip
  });
  if (softlinkInfoTooltip) {
    softlinkInfoTooltip.open();
  }
  setTimeout(function(){
    softlinkInfoTooltip.close();
  }, 5000);

  var linkTriggerUpdateStore = document.querySelector('.softlink_updatestore');
  linkTriggerUpdateStore.addEventListener('click', function (event) {
    softlinkInfoTooltip.close();
  })
}

/**
 * * Public Methods
 */
storeFinder.init = function _init() {
  Localizer.localize().then(function (response) {
    privateData.myStore = response.getLocalizedStore() || {
      storeId: '0121'
    };

    const addTooltipHandler = () => {
      if (Localizer.status.isSelfLocalized() || Localizer.status.isAutoLocalized()) {
        privateMethods.attachTooltipToMyStore();
        document.addEventListener('closeStoreFinderTooltip', () => {
          if (storeFinderTooltip) {
            storeFinderTooltip.close();
          }
        })
        document.addEventListener('openStoreFinderTooltip', () => {
          if (storeFinderTooltip) {
            storeFinderTooltip.open();
          }
        })
      }
      addListenersToAll(['click', 'touchend'], '#myStore', headerStorefinderCore.handleClickOnStorefinder);
    };

    // * Original code put the function in the $doc.ready(), but when using vanilla DOMContentLoaded the function
    // * was not running. It appears that when we got here, DOMContentLoaded had already fired.
    // * After some testing, it appears that jQuery safeguarded against this, so we need to do the same.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addTooltipHandler);
    } else {
      addTooltipHandler();
    }

  });

  Localizer.on('selectedZipNotInRange', function(){
    storeFinder.softLink()
  });

  delegateListeners(['click', 'touchend'],
    '#myStoreDropdown [rel="hfLocModal"]', headerStorefinderCore.closeMenuWithDelay);
  delegateListeners(['click', 'touchend'], '[rel="hfLocModal"]', privateMethods.toggleDrawer);
  delegateListeners(['click','touchend'], '#simpleMenuButton', privateMethods.closeDrawer);

  document.addEventListener('launchLocDrawer', privateMethods.toggleDrawer);
  document.addEventListener('updateStoreTitle', privateMethods.updateStoreTitle);
  $(document).on('closeDrawer', privateMethods.closeDrawer)

  // TODO: jQueryRemoval
  // * Leaving as jQuery until search is converted
  document.addEventListener('searchState', privateMethods.closeDrawer);

  return this;
};

storeFinder.getPrivateMethods = function getPrivateMethods() {
  return privateMethods;
};

storeFinder.getPrivateData = function getPrivateData() {
  return privateData;
};

export default storeFinder;
